import { FC } from "react";
import styles from "./index.module.scss";
import { ProductCard } from "@/components/product-card";
import { Product } from "@/types/product";
import useCashRegisterStore from "@/stores/cash-register";
import { logFirebaseEvent } from "@/services/firebase";
import { playSound, SoundOption } from "@/helpers/playSound";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { addProduct } from "@/store/cart/thunk";
import { useAppSelector } from "@/hooks/useAppSelector";
import { selectProducts } from "@/store/product/selectors";

interface ProductRowProps {
  onSearchPress: () => void;
}

const ProductRow: FC<ProductRowProps> = ({ onSearchPress }) => {
  const dispatch = useAppDispatch();
  const { products } = useAppSelector(selectProducts);
  const { current } = useCashRegisterStore();

  const onClick = (productId: Product["id"]) => {
    playSound(SoundOption.Click1);
    dispatch(addProduct(productId));

    const product = products.find((product) => product.id === productId);
    if (!product) return;
    logFirebaseEvent("shortcut_product_card_pressed", {
      id: product.id,
      name: product.translations[0].name,
    });
  };

  return (
    <div className={styles.container} data-cy="product-row">
      <ProductCard onClick={onSearchPress} className={styles.card} />
      {current?.shop.shortcutProductIds.map((productId) => (
        <ProductCard
          key={productId}
          productId={productId}
          onClick={() => onClick(productId)}
          className={styles.card}
        />
      ))}
    </div>
  );
};

export default ProductRow;
